const menu_data = [
    {
      id: 1,
      has_dropdown: true,
      title: "الرئسية",
      link: "#",
    },
    {
      id: 2,
      has_dropdown: true,
      title: "الخدمات",
      link: "#serviceid",
    },
    {
      id: 3,
      has_dropdown: true,
      title: "نبذه عن المركز",
      link: "#aboutid",
    },
    {
      id: 4,
      has_dropdown: true,
      title: "طريقة العمل",
      link: "#workid",
    },
    {
      id: 5,
      has_dropdown: true,
      title: "الأسئلة الشائعة",
      link: "#faqid",
    },
    {
      id: 6,
      has_dropdown: true,
      title: "تواصل معنا",
      link: "#opeantimeid",
    },
  ];
  
  export default menu_data;
  